export default __webpack_public_path__ + "static/media/circleForegroundRightLight.74b6b3d1.svg";